export const state = {
    orderList: {
        records: [],
        totalRecords: { open: 0, cancel: 0, filled: 0 }
    },
    orderListSocial: {
        records: [],
        totalRecords: { open: 0, cancel: 0, filled: 0 }
    },
    // orderList: {
    //     open_orders: [],
    //     cancel_orders: [],
    //     filled_orders: []
    // },
    ipAddress: [],
    portfolioReport: [],
    revenueReport: [],
    combinedCurrency: [],
    uniqueCurrency: [],
    depositHistoryList: [],
    withdrawalHistoryList: [],
    tradingAccount: [],
    socialAccount: [],
    notificationList: {},
    margin_list: {},
    margin_list_social: {},
    accountSelected: 0,
    watchListPairs: [],
    cryptoList: [],


}


// WEBPACK FOOTER //
// ./src/plugins/trading/provider/store-addons/state.js